import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1.5, 2),
    alignItems: 'center',

    [theme.breakpoints.down('x-xs')]: {
      flexDirection: 'column',
      textAlign: 'center',
    },

    [theme.breakpoints.up('md')]: {
      minHeight: theme.spacing(15.75),
    },
  },

  title: {
    fontSize: theme.spacing(2),
    fontFamily: '"Noto Sans"',
    fontWeight: 700,
    lineHeight: theme.spacing(2.75),
    letterSpacing: theme.spacing(0.15),
    wordWrap: 'break-word',
    marginBottom: theme.spacing(1),
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: '1',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },

  description: {
    fontSize: theme.spacing(1.75),
    fontFamily: '"Noto Sans"',
    fontWeight: 400,
    lineHeight: theme.spacing(3),
    letterSpacing: theme.spacing(0.125),
    marginRight: 'auto',

    [theme.breakpoints.up('x-xs')]: {
      wordWrap: 'break-word',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: '3',
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      paddingRight: theme.spacing(2),
    },

    [theme.breakpoints.down('x-xs')]: {
      paddingBottom: theme.spacing(2),
    },
  },

  icon: {
    display: 'flex',
    alignItems: 'center',
    minWidth: theme.spacing(6.25),
    minHeight: theme.spacing(6.25),
    marginRight: theme.spacing(3.75),

    [theme.breakpoints.up('md')]: {
      maxWidth: theme.spacing(3.75),
      maxHeight: theme.spacing(3.75),
    },

    [theme.breakpoints.down('x-xs')]: {
      paddingBottom: theme.spacing(2),
      marginRight: theme.spacing(0),
    },

    '& img': {
      width: '100%',
      objectFit: 'contain',
    },
  },

  button: {
    minWidth: theme.spacing(14),
    fontSize: theme.spacing(1.75),
    fontFamily: '"Noto Sans"',
    fontWeight: 700,
    borderColor: theme.palette.primary.main,
  },
}));
